/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import { areEqual } from 'fierry/type/compare';

import TransformZone from 'solis/react/board/data/transform.zone';


export default class extends Logic
{
  constructor ({ data, transform })
  {
    super(data);

    this.transform = transform;
  }


  equals (other)
  {
    return super.equals(other) && areEqual(this.transform, other.transform);
  }


  getCenterDisplayHex ()
  {
    return this.object.getCenterDisplayHex().transformWithObject(this.transform);
  }


  getZone (displayHex)
  {
    const zone = this.object.getZone(displayHex.inverseTransformWithObject(this.transform));

    return zone !== null ? new TransformZone(zone, this) : null;
  }


  getZones ()
  {
    return this.object.getZones().map(zone => new TransformZone(zone, this));
  }


  getSelectableZone (displayHex)
  {
    const zone = this.object.getSelectableZone(displayHex.inverseTransformWithObject(this.transform));

    return zone !== null ? new TransformZone(zone, this) : null;
  }


  toEntityHex (displayHex)
  {
    return this.object.toEntityHex(displayHex.inverseTransformWithObject(this.transform));
  }


  toDisplayHex (entityHex)
  {
    return this.object.toDisplayHex(entityHex).transformWithObject(this.transform);
  }


};
